<zef-form
  [state]="state"
  (submit)="submit.emit()">

  <zui-user-info-fields
    [firstName]="state?.controls?.firstName"
    [lastName]="state?.controls?.lastName"
    [email]="state?.controls?.email"
    [translations]="userInfoFieldsTranslations">
  </zui-user-info-fields>

  <ng-content></ng-content>

</zef-form>
